'use client';

import { UserCredential } from '@/lib/auth/token';
import React, { createContext, useContext, ReactNode } from 'react';

interface UserCredentialContextType {
  userCredential: UserCredential | null;
}

const UserCredentialContext = createContext<UserCredentialContextType | undefined>(undefined);

export function UserCredentialProvider({ children, userCredential }: { children: ReactNode; userCredential: UserCredential | null }) {
  return (
    <UserCredentialContext.Provider value={{ userCredential: userCredential }}>
      {children}
    </UserCredentialContext.Provider>
  );
}

export function useUserCredential() {
  const context = useContext(UserCredentialContext);
  if (context === undefined) {
    throw new Error('useUserCredential must be used within a UserCredentialProvider');
  }
  return context.userCredential;
}